.headingSelector {
	position: relative;
}

.headingDropdown {
	position: absolute;
	display: grid;
	grid-template-columns: 1fr;
	top: 100%;
	width: max-content;
	background: $whiteColor;
	z-index: 30;
	border-radius: 8px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
	border: 1px solid $greyColor5;
	padding: 8px 0;
}

.headingOption {
	padding: 8px 16px;
	border: none;
	background: none;
	width: 100%;
	text-align: left;
	cursor: pointer;
	line-height: 1.2;
	color: $blackColor;
	transition: all 0.2s ease;
	font-family: inherit;

	&:hover {
		background: rgba($activeColor, 0.08);
	}

	&.active {
		background: rgba($activeColor, 0.12);
		color: $activeColor;
		font-weight: 500;
	}

	&:not(:last-child) {
		border-bottom: 1px solid rgba($greyColor, 0.3);
	}

	&[data-level='1'] {
		font-size: 20px;
		font-weight: 700;
		letter-spacing: -0.5px;
	}

	&[data-level='2'] {
		font-size: 18px;
		font-weight: 600;
		letter-spacing: -0.3px;
	}

	&[data-level='3'] {
		font-size: 16px;
		font-weight: 600;
	}

	&[data-level='4'] {
		font-size: 15px;
		font-weight: 600;
	}

	&[data-level='5'] {
		font-size: 14px;
		font-weight: 600;
	}

	&[data-level='6'] {
		font-size: 13px;
		font-weight: 600;
		color: $darkGrey;
	}
}
